
import { createRoot } from "react-dom/client";
import {createBrowserRouter,RouterProvider,} from "react-router-dom";
import App from "./App";
import { AllData } from "./Data/AllData";
import ScrollToTop from "react-scroll-to-top";
import AllAbout from "./About/AllAbout";
import AllService from "./Service/AllService";
import AllPages from "./Pages/AllPages";
import AllBooking from "./Booking/AllBooking";
import AllTechnicians from "./Technicians/AllTechnicians";
import AllTestimonial from "./Testimonial/AllTestimonial";
import AllContact from "./Contact/AllContact";
import AllProducts from "./Products/AllProducts";
import AllShop from "./Shop/AllShop";
import AllCart from "./Cart/AllCart";
const router = createBrowserRouter([
  {
    path: "/",
    element: <App/>,
  },
  {
    path: "about",
    element: <AllAbout/>,
  },
  {
    path: "service",
    element: <AllService/>,
  },
  {
    path: "testimonial",
    element: <AllTestimonial/>,
  },
  {
    path: "pages",
    element: <AllPages/>,
  },
  {
    path: "booking",
    element: <AllBooking/>,
  },
  {
    path: "technicians",
    element: <AllTechnicians/>,
  },

  {
    path: "contact",
    element: <AllContact/>,
  },
  {
    path: "products",
    element: <AllProducts/>,
  },
  {
    path: "shop",
    element: <AllShop/>,
  },
  {
    path: "cart",
    element: <AllCart/>,
  },
 
]);

createRoot(document.getElementById("root")).render(
  <AllData>
    <RouterProvider router={router} />
    <ScrollToTop 
    smooth 
    />
  </AllData>
);


